const { FLAG } = require('base/src/utils/flag');

FLAG.TRANSLATION = true;

module.exports = {
  FLAG,
};
